import {DataSets} from '../components/payroll-checklist/checklist';
import {listHasTime} from '../../views/wrapper/payroll/payroll-step/payroll';
import { uniq } from 'lodash';

export function reorderColumns(defaultLists: DataSets[], selectedList: string[]): any[] {
  const arr = [];
  defaultLists.map(item => {
    if (listHasTime.includes(item.labelEn) && selectedList.includes(`${item.labelEn}_${item.timeUnit}`)) {
      arr.push(`${item.labelEn}_${item.timeUnit}`);
    } else if (selectedList.includes(item.labelEn)) {
      arr.push(item.labelEn);
    }
  });
  // extra columns
  const notime = selectedList.filter(item => !listHasTime.includes(item.split('_')[0]));
  const extraCol = notime.filter(item => !defaultLists.map(i => i.labelEn).includes(item));
  if (extraCol.length > 0) {
    extraCol.map(item => arr.push(item));
  }
  return uniq(arr);
}

export const columnToLetter = (column): string => {
  let temp;
  let letter = '';
  while (column > 0) {
    temp = (column - 1) % 26;
    letter = String.fromCharCode(temp + 65) + letter;
    column = (column - temp - 1) / 26;
  }
  return letter;
}

export const getCellKey = (index, y): string => {
 return columnToLetter(index+1)+(+y + 1);
}